import { NEW_COLORS } from '../../themes/colors/newColors';
import { PulsarAnimation } from './styles';

interface PulsarAnimationProps {
  width?: string;
  height?: string;
  color?: string;
}

export const PulsarAnimationLoading = ({
  width = '10px',
  height = '10px',
  color = NEW_COLORS.SECONDARY[500],
}: PulsarAnimationProps) => {
  return <PulsarAnimation width={width} height={height} color={color} />;
};
